var capitalize = require('./capitalize');
var camelize = require('./camelize');
var makeString = require('./helper/makeString');

module.exports = function classify(str) {
  str = makeString(str);
  return capitalize(camelize(str.replace(/[\W_]/g, ' ')).replace(/\s/g, ''));
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/classify.js
// module id = 461
// module chunks = 0